"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShortcutSettingsViewItems = void 0;
const getShortcutSettingsViewItems = (shortcut) => {
    var _a, _b;
    const values = [
        `Shortcut Key: ${shortcut.ShortcutKey || 'Not selected'}`,
        `Value: ${(_a = shortcut.ShortcutValue) !== null && _a !== void 0 ? _a : 'Not specified'}`,
        `Operation: ${(_b = shortcut.ShortcutOperation) !== null && _b !== void 0 ? _b : 'Not Specified'}`,
    ];
    return {
        name: 'Settings',
        values,
    };
};
exports.getShortcutSettingsViewItems = getShortcutSettingsViewItems;
